<template>
  <div class="app-box" :class="{ 'app-box-class': isOpenLittleYellowManUi }">
    <template v-if="orderStatus >= -1 && !isTimeout24Hours">
      <div class="orderlocation" :ref="mapDomId"></div>
      <!-- 麦当劳	-->
      <div class="mcDonaIds-box" v-if="isOpenLittleYellowManUi">
        <div class="mcDonaIds-box-left">
          <img src="./images/minionsLogo.png" />
        </div>
        <div class="mcDonaIds-box-right">
          <div class="phone-right" v-if="orderStatus > 1">
            <a :href="'tel:' + riderPhone">
              <img src="./images/MacIcon_phone.png" />
            </a>
          </div>
          <div class="con-right">
            <p v-if="orderStatus >= -1 && orderStatus < 100">
              预计送达<span class="ml">{{ deliveryTime }}</span>
            </p>
            <!--<p class="order-success" v-if="orderStatus == 100">
                    <img src="./images/img_success.png">
            </p>-->
            <p v-if="orderStatus == -1 || orderStatus == 1">
              <span class="mr">{{ riderName }}</span
              >餐品正在制作中
            </p>
            <p v-if="orderStatus == 2 || orderStatus == 3">
              <span class="mr">{{ riderName }}</span
              >骑手正赶往商家
            </p>
            <p v-if="orderStatus == 4">
              <span class="mr">{{ riderName }}</span
              >骑手正在配送
            </p>
            <p v-if="orderStatus == 100">
              <span class="mr">{{ riderName }}</span
              >订单已完成
            </p>
          </div>
        </div>
      </div>
      <!-- 标准版	-->
      <div class="rider-box" v-else>
        <div class="rider-status-box">
          <p
            class="rider-delivery-time"
            v-if="orderStatus >= -1 && orderStatus < 100"
          >
            预计送达<span class="delivery-time">{{ deliveryTime }}</span>
          </p>
          <p class="order-success" v-if="orderStatus == 100">
            <img src="./images/img_success.png" />
          </p>
          <p
            class="rider-status-content"
            v-if="orderStatus == -1 || orderStatus == 1"
          >
            餐品正在制作中
          </p>
          <p
            class="rider-status-content"
            v-if="orderStatus == 2 || orderStatus == 3"
          >
            骑手正赶往商家
          </p>
          <p class="rider-status-content" v-if="orderStatus == 4">
            骑手正在配送
          </p>
          <p class="rider-status-content" v-if="orderStatus == 100">
            订单已完成
          </p>
        </div>
        <div class="rider-phone-box" v-if="orderStatus > 1">
          <div class="rider-phone-left">
            <img src="./images/img_riderImg.png" /><span>{{ riderName }}</span>
          </div>
          <div class="rider-phone-right">
            <a :href="'tel:' + riderPhone">
              <img src="./images/icon_phone.png" />
            </a>
          </div>
        </div>
      </div>
    </template>
    <template v-if="isTimeout24Hours || orderStatus == -100">
      <div class="timeout-24hours">
        <img v-if="isTimeout24Hours" src="./images/img_timeout.png" />
        <img
          v-if="orderStatus == -100 && !isTimeout24Hours"
          src="./images/img_cancel.png"
        />
      </div>
    </template>
    <template v-if="isErrorPage">
      <div class="error-page">
        <img src="./images/404.png" />
      </div>
    </template>
  </div>
</template>

<script>
// 引入地图插件
import amap from "../index/plugs/amap";
import tmap from "../index/plugs/tmap";
let _this = null;
window.getMapInfo = function () {
	console.log(1)
	_this.getOrderMapInfo({ orderId: _this.orderId });
  if (_this.orderStatus != 100) {
    setInterval(() => {
      _this.getOrderMapInfo({ orderId: _this.orderId });
    }, 15000);
  }
};

export default {
  data() {
    return {
      deliveryTime: "19:26", // 预送达时间
      riderName: "xxx", // 骑士姓名
      riderPhone: "xxx-xxxxxxxx", // 骑士电话
      riderLng: 113.233517, // 骑士经度
      riderLat: 23.091767, // 骑士纬度
      customerLng: 116.390521, // 顾客经度
      customerLat: 39.896958, // 顾客纬度
      storeLng: 113.238023, // 门店经度
      storeLat: 23.101735, // 门店纬度
      orderStatus: 100, // 订单状态(-1:平台接单;1:指派骑手;2:骑手接单;3:到店取餐;4:取餐出发;5:保留订单；6:拒绝订单;100:已送达;-100:已取消;-110:饱和转派)
      isTimeout24Hours: false, // 订单是否已超时24小时
      customerDistance: "1.83KM", // 骑手与顾客距离
      storeDistance: "2.25KM", // 骑手与门店距离
      images: {
        customerIcon: require("project/orderLocation/images/icon_customer.png"),
        storeIcon: require("project/orderLocation/images/icon_store.png"),
        riderIcon: require("project/orderLocation/images/icon_rider.png"),
        mcDonaIdsLogo: require("project/orderLocation/images/McDonaldsLogo.png"),
        minions: require("project/orderLocation/images/minions.png"),
        customer: require("project/orderLocation/images/customer.png"),
      },
      isErrorPage: false, // 是否错误页面
      isOpenLittleYellowManUi: false, //是否启用小黄人UI界面
      orderId: "",
      mapDomId: "",
      mapType: 0,
			mapObj:null,
    };
  },
  created() {
    this.mapDomId = "orderlocation_" + new Date().getTime();
  },
  mounted() {
    _this = this;
    let href = window.location.href,
      query = href.split("?")[1],
      queryArray = query.split("&");
    if (queryArray && queryArray.length) {
      for (let i = 0; i < queryArray.length; i++) {
        if (queryArray[i].indexOf("orderId") != -1) {
          this.orderId = queryArray[i].split("=")[1];
          break;
        }
      }
      this.$nextTick(() => {
        this.initMap();
      });
    }
  },
  computed: {},
  methods: {
    // 获取与送达时间格式
    getDeliveryTime(time) {
      let hours = new Date(time).getHours();
      let minutes = new Date(time).getMinutes();
      return (
        (hours < 10 ? "0" + hours : hours) +
        ":" +
        (minutes < 10 ? "0" + minutes : minutes)
      );
    },
    getOrderMapInfo(data) {
      let me = this;
      if (!data.orderId) {
        this.isErrorPage = true;
        return;
      }
      Com.vm.$service.get("getOrderMapInfo", data).then((result) => {
        if (!result.$.checkResult(result, true)) {
          return;
        }
        me.deliveryTime = me.getDeliveryTime(result.data.expectedFinishTime);
        me.riderName = result.data.horsemanName;
        me.riderPhone = result.data.horsemanPhone;
        me.riderLng = result.data.horsemanLng;
        me.riderLat = result.data.horsemanLat;
        me.customerLng = result.data.receiverLng;
        me.customerLat = result.data.receiverLat;
        me.storeLng = result.data.storeLng;
        me.storeLat = result.data.storeLat;
        me.orderStatus = result.data.orderStatus;
        me.isTimeout24Hours = result.data.isTimeout24Hours;
        me.isOpenLittleYellowManUi = result.data.isOpenLittleYellowManUi;
        me.customerDistance =
          result.data.customerDistance > 1000
            ? (result.data.customerDistance / 1000).toFixed(2) + "KM"
            : result.data.customerDistance + "M";
        me.storeDistance =
          result.data.storeDistance > 1000
            ? (result.data.storeDistance / 1000).toFixed(2) + "KM"
            : result.data.storeDistance + "M";
        if (me.orderStatus >= -1 && !me.isTimeout24Hours) {
          const markerStyle = {
            customericon: {
              src: result.data.isOpenLittleYellowManUi
                ? me.images.customer
                : me.images.customerIcon,
              width: result.data.isOpenLittleYellowManUi ? 70 : 50,
              height: result.data.isOpenLittleYellowManUi ? 45 : 55,
              direction: "bottom",
            },
            storeIcon: {
              src: result.data.isOpenLittleYellowManUi
                ? me.images.mcDonaIdsLogo
                : me.images.storeIcon,
              width: result.data.isOpenLittleYellowManUi ? 58 : 50, //图标大小
              height: result.data.isOpenLittleYellowManUi ? 58 : 55, //图标大小
              direction: "bottom",
            },
            riderIcon: {
              src: result.data.isOpenLittleYellowManUi
                ? me.images.minions
                : me.images.riderIcon,
              width: result.data.isOpenLittleYellowManUi ? 97 : 70,
              height: result.data.isOpenLittleYellowManUi ? 97 : 85,
              direction: "bottom",
              color: "#f37563", // 标注点文本颜色
              size: 30, // 标注点文本文字大小
            },
          };
					if(!this.mapObj){
						this.mapObj=AMAP.initMap(this.$refs[this.mapDomId], {
							center: [me.storeLng, me.storeLat],
							zoom: 13,
						});
					}else{
						AMAP.clearMap(this.$refs[this.mapDomId])
					}
          // 添加顾客位置
          AMAP.addMarker(
            this.$refs[this.mapDomId],
            {
              lng: me.customerLng,
              lat: me.customerLat,
              icon: {
                image: result.data.isOpenLittleYellowManUi
                  ? me.images.customer
                  : me.images.customerIcon,
                width: result.data.isOpenLittleYellowManUi ? 70 : 50,
                height: result.data.isOpenLittleYellowManUi ? 45 : 55,
                styleId: "customericon",
              },
              zIndex: 999,
              zoom: 15,
              markerStyle: markerStyle,
            },
            {}
          );
          // 添加门店位置(orderStatus>=1&&orderStatus<100)
          if (me.orderStatus < 100) {
            AMAP.addMarker(
              this.$refs[this.mapDomId],
              {
                lng: me.storeLng,
                lat: me.storeLat,
                icon: {
                  image: result.data.isOpenLittleYellowManUi
                    ? me.images.mcDonaIdsLogo
                    : me.images.storeIcon,
                  width: result.data.isOpenLittleYellowManUi ? 58 : 50,
                  height: result.data.isOpenLittleYellowManUi ? 58 : 55,
                  styleId: "storeIcon",
                },
                zIndex: 999,
                zoom: 15,
                markerStyle: markerStyle,
              },
              {}
            );
            // map.add(storeMarker);
            // markerList.push(storeMarker);
          }
          // 添加骑手位置(orderStatus>1&&orderStatus<100)
          if (me.orderStatus > 1 && me.orderStatus < 100) {
            let content = "";
            if (me.orderStatus < 4) {
              if (this.mapType == 1) {
                content = `距离门店 ${me.storeDistance}`;
              } else {
                content =
                  '距离门店<span style="' +
                  "color:#f37563;margin-left:4px;" +
                  '">' +
                  me.storeDistance +
                  "</span>";
              }
            } else {
              if (this.mapType == 1) {
                content = `距离您 ${me.customerDistance}`;
              } else {
                content =
                  '距离您<span style="' +
                  "color:#f37563;margin-left:4px;" +
                  '">' +
                  me.customerDistance +
                  "</span>";
              }
            }

            AMAP.addMarker(
              this.$refs[this.mapDomId],
              {
                lng: me.riderLng,
                lat: me.riderLat,
                icon: {
                  image: result.data.isOpenLittleYellowManUi
                    ? me.images.minions
                    : me.images.riderIcon,
                  width: result.data.isOpenLittleYellowManUi ? 97 : 70,
                  height: result.data.isOpenLittleYellowManUi ? 97 : 85,
                  styleId: "riderIcon",
                },
                label: {
                  content: content,
                  offset: {
                    x: result.data.isOpenLittleYellowManUi ? -30 : -70,
                    y: 0,
                  },
                },
                zIndex: 999,
                zoom: 15,
                markerStyle: markerStyle,
              },
              {}
            );
          }
          AMAP.setFitView(this.$refs[this.mapDomId],{padding:{top:100, bottom:600, left:100, right:100}});
        }
      });
    },
    //根据接口返回的地图key初始化地图,然后查询订单信息
    initMap() {
      Com.vm.$service
        .get("getOrderMapInfo", { orderId: this.orderId })
        .then((result) => {
          if (!result.$.checkResult(result, true)) {
            return;
          }
					// result.data.mapType = 1
          this.mapType = result.data.mapType;
					this.orderStatus = result.data.orderStatus;
          if (result.data.mapType == 0) {
            //高德地图
            window.AMAP = amap;
          } else if (result.data.mapType == 1) {
            //腾讯地图
            window.AMAP = tmap;
          } else {
            //默认的高德地图
            window.AMAP = amap;
          }

          window.AMAP.loaded(
            "1.4.13",
            result.data.mapKey,
            "getMapInfo",
            result.data.mapSecret
          );
        });
    },
  },
  components: {},
};
</script>

<style scoped>
</style>

<style lang="scss">
.orderlocation {
  width: 100%;
  height: 100%;
}
.app-box-class {
  .amap-marker {
    .amap-marker-label {
      background-color: #ffdc0d;
      font-weight: bold;
      &:after {
        border: 0.3rem solid #ffdc0d;
        border-color: transparent transparent #ffd900 #ffdc0d;
      }
      span {
        color: #333 !important;
      }
    }
  }
  .mcDonaIds-box {
    position: absolute;
    width: 100%;
    bottom: 2rem;
    background: #ffdc0d;
    .mcDonaIds-box-left {
      position: absolute;
      left: 0px;
      bottom: 50%;
      -webkit-transform: translate(0px, 40%);
      transform: translate(0px, 40%);
      width: 10rem;
      height: 10rem;
      img {
        width: 100%;
      }
    }
    .mcDonaIds-box-right {
      padding: 1.2rem 0;
      .phone-right {
        position: absolute;
        right: 0.5rem;
        bottom: 1rem;
        width: 2.75rem;
        height: 0.375rem;
        img {
          width: 100%;
        }
      }
      .con-right {
        font-size: 0.75rem;
        margin-left: 8.8rem;
        color: #000;
        p {
          line-height: 1.3rem;
          span {
            font-weight: bold;
          }
          .ml {
            margin-left: 0.5rem;
          }
          .mr {
            margin-right: 0.5rem;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// index.vue?6009b539